export const IMAGEBANK_REQUEST = "IMAGEBANK_REQUEST";
export const IMAGEBANK_SUCCESS = "IMAGEBANK_SUCCESS";
export const IMAGEBANK_FAILURE = "IMAGEBANK_FAILURE"